import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    '& .react-tel-input .form-control': {
      width: 'inherit',
      height: 'inherit',
      paddingLeft: 'calc(16px + 0.5rem)'
    },

    '& .react-tel-input > *': {
      border: 'none',
      backgroundColor: 'transparent'
    },

    '& .react-tel-input .selected-flag': {
      width: '16px',
      padding: '0',
      cursor: 'default'
    }
  }
}))

export default useStyles
